module.exports = __webpack_public_path__ + "static/media/premierOneRightSeatMobileSelected.792ecdcf.svg";